import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Search, Calendar, MousePointerClick, Zap } from 'lucide-react'
import type { DashboardStats } from '../hooks/useDashboardStats'

interface StatsCardsProps {
  stats: DashboardStats['overview'] | undefined
  isLoading: boolean
}

export function StatsCards({ stats, isLoading }: StatsCardsProps) {
  const cards = [
    {
      title: 'Searches Today',
      value: stats?.searchesToday ?? 0,
      icon: Search,
      format: (v: number) => v.toLocaleString(),
    },
    {
      title: 'Searches This Month',
      value: stats?.searchesMonth ?? 0,
      icon: Calendar,
      format: (v: number) => v.toLocaleString(),
    },
    {
      title: 'Click-Through Rate',
      value: stats?.clickThroughRate ?? 0,
      icon: MousePointerClick,
      format: (v: number) => `${v.toFixed(1)}%`,
    },
    {
      title: 'Avg Latency',
      value: stats?.avgLatencyMs ?? 0,
      icon: Zap,
      format: (v: number) => `${v.toFixed(1)}ms`,
    },
  ]

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon
        return (
          <Card key={card.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
              <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              {isLoading ? (
                <Skeleton className="h-8 w-20" />
              ) : (
                <div className="text-2xl font-bold">{card.format(card.value)}</div>
              )}
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}
